import React from 'react';
import { BookOpenIcon, FilterIcon, CalculatorIcon, ShieldIcon, CheckSquareIcon, CheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-6 h-6 text-brand-gold" data-id="element-123" />,
    title: 'El Método Anti-Tipster (PDF)',
    description: 'Valor: $97\nConstruye un criterio que te permita detectar apuestas con ventaja…'
  }, {
    icon: <FilterIcon className="w-6 h-6 text-brand-gold" data-id="element-124" />,
    title: 'El Protocolo de Confirmación de 5 Pasos',
    description: 'Valor: $147\nEl filtro exacto que evita apuestas impulsivas…'
  }, {
    icon: <CalculatorIcon className="w-6 h-6 text-brand-gold" data-id="element-125" />,
    title: 'Calculadora de Probabilidad Implícita',
    description: 'Valor: $47 Para saber si una cuota es un regalo o una trampa.'
  }, {
    icon: <ShieldIcon className="w-6 h-6 text-brand-gold" data-id="element-126" />,
    title: 'Guía de Gestión de Banca',
    description: 'Valor: $197 Cómo dividir tu capital en unidades para que nunca vuelvas a quemar una cuenta.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6 text-brand-gold" data-id="element-127" />,
    title: 'Checklist Pre-Partido',
    description: 'Valor: $27 La lista de verificación que usan los profesionales antes de operar.'
  }];
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        <h2 className="text-3xl md:text-4xl text-center text-brand-text mb-12" data-id="element-130">
          Lo que obtienes hoy:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-131">
          {items.map((item, index) => <div key={index} className={`bg-brand-card border border-brand-gold/10 rounded-xl p-6 flex items-start gap-4 hover:border-brand-gold/30 transition-colors ${index === items.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-132">
              <div className="p-3 bg-brand-bg rounded-lg border border-brand-gold/20 shrink-0" data-id="element-133">
                {item.icon}
              </div>
              <div data-id="element-134">
                <h3 className="text-xl text-brand-text mb-2" data-id="element-135">{item.title}</h3>
                <p className="text-brand-muted" data-id="element-136">{item.description}</p>
              </div>
            </div>)}
        </div>

        {/* Value Breakdown */}
        <div className="mt-12 max-w-2xl mx-auto bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8" data-id="element-137">
          <h3 className="text-2xl md:text-3xl text-center text-brand-gold mb-6 font-bold" data-id="element-138">
            💰 VALOR REAL DEL SISTEMA: $515 USD
          </h3>

          <div className="space-y-3 mb-6" data-id="element-139">
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-140">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-141" />
              <span data-id="element-142">Método Anti-Tipster → $97</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-143">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-144" />
              <span data-id="element-145">Protocolo 5 pasos → $147</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-146">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-147" />
              <span data-id="element-148">Calculadora → $47</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-149">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-150" />
              <span data-id="element-151">Gestión de banca → $197</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-152">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-153" />
              <span data-id="element-154">Checklist → $27</span>
            </div>
          </div>

          <div className="border-t border-brand-gold/20 pt-6" data-id="element-155">
            <div className="text-center space-y-4" data-id="element-156">
              <p className="text-lg md:text-xl text-brand-muted" data-id="element-157">
                HOY TIENES ACCESO COMPLETO POR:
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-158">
                <span className="text-2xl md:text-3xl text-brand-muted line-through opacity-60" data-id="element-159">
                  $515 USD
                </span>
                <span className="text-5xl md:text-7xl text-brand-gold font-bold animate-pulse" data-id="element-160">
                  $6.39
                </span>
              </div>
              <div className="inline-block bg-brand-gold/20 border-2 border-brand-gold rounded-full px-6 py-2" data-id="element-161">
                <p className="text-xl md:text-2xl text-brand-gold font-bold" data-id="element-162">
                  🔥 98% DE DESCUENTO 🔥
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}